// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2o-6";
export var headerCell = "_2o-2";
export var rowWrapper = "_2o-4";
export var stickyAggregationCell = "_2o-a";
export var stickyAggregationRow = "_2o-7";
export var stickyColumnCell = "_2o-9";
export var stickyColumnHeaderCell = "_2o-8";
export var table = "_2o-1";
export var virtualRowWrapper = "_2o-5";
export var virtualTableContainer = "_2o-0";
export var white = "_2o-3";